import { sqliteTable, text } from "drizzle-orm/sqlite-core";
import { OfflineDownloadStatus } from "../constants";
import { timestamps } from "../utils/fields";

export const offlineTracks = sqliteTable("offline_tracks", {
  ...timestamps,
  trackId: text("track_id").primaryKey(),
  title: text("title").notNull(),
  audioUrl: text("audio_url").notNull(),
  audioLocalPath: text("audio_local_path"),
  audioDownloadStatus: text("audio_download_status", {
    enum: [
      OfflineDownloadStatus.PENDING,
      OfflineDownloadStatus.PAUSED,
      OfflineDownloadStatus.DOWNLOADING,
      OfflineDownloadStatus.COMPLETED,
      OfflineDownloadStatus.FAILED,
      OfflineDownloadStatus.MARKED_FOR_DELETION,
      OfflineDownloadStatus.NEEDS_REDOWNLOAD,
    ],
  }).notNull(),
  rawData: text("raw_data", { mode: "json" }).notNull().$type<{
    forCollectionId: string;
    forCollectionType: "album" | "playlist";
    [key: string]: unknown;
  }>(),
});

export type OfflineTrack = typeof offlineTracks.$inferSelect;
